import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { CreditFacilityReceivablesDashboardRoute } from 'borrower/routes/receivables/CreditFacilityReceivablesDashboardRoute';
import { useCreditFacilityContext } from 'packages/credit-facility/hooks/CreditFacilityProvider';
import { AthenaSchemaProvider } from 'packages/organization/hooks/AthenaSchemaContext';

export const CreditFacilityReceivablesDashboardRouter = ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { creditFacilityId } = useCreditFacilityContext();

  return (
    <AthenaSchemaProvider organizationId={organizationId}>
      <Switch>
        <Route
          exact
          path="/credit-facility-receivables/:creditFacilityId"
          component={CreditFacilityReceivablesDashboardRoute}
        />
        <Redirect to={`/credit-facility-receivables/${creditFacilityId}`} />
      </Switch>
    </AthenaSchemaProvider>
  );
};
